<template>
  <div
    class="tfa-setup"
    @keyup.enter="qrSetup"
  >
    <div class="header">
      <PrimaryLogo class="logo" />
    </div>
    <div class="wrapper">
      <div class="top">
        <a
          class="back-link"
          @click="signOut"
        >
          <i class="fas fa-chevron-left" />
          {{ $t('tfaSetupView.backLink') }}
        </a>
        <span
          class="title"
          v-html="$t('tfaSetupView.title')"
        />
        <span
          class="step"
          v-html="$t('tfaSetupView.steps[0]')"
        />
        <div class="apps">
          <a
            href="https://apps.apple.com/ru/app/google-authenticator/id388497605"
            class="app-link"
          >
            <img
              src="@/assets/images/apps/app-store-button.png"
              alt="App Store"
              class="app-logo"
            >
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
            class="app-link"
          >
            <img
              src="@/assets/images/apps/google-play-button.png"
              alt="Google Play"
              class="app-logo"
            >
          </a>
          <img
            src="@/assets/images/apps/app-icon.png"
            alt="Google Authenticator"
            class="app-logo"
          >
          <span class="gagg">{{ $t('tfaSetupView.google') }}<br>{{
            $t('tfaSetupView.authenticator')
          }}</span>
        </div>
      </div>
      <div class="step-2-wr">
        <img
          :src="qrSrc"
          class="qr"
        >
        <div
          v-loading="isLoading"
          class="code-form"
        >
          <span
            class="step"
            v-html="$t('tfaSetupView.steps[1]')"
          />
          <UiCodeInput
            :field-width="35"
            :field-height="35"
            auto-focus
            @complete="confirmCode"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  AUTH_2FA_REQUEST,
  AUTH_2FA_SUCCESS,
  AUTH_LOGOUT,
} from '@/store/action_types/auth';
import { bootstrapApp } from '@/setup/bootstrap';

import PrimaryLogo from '@/components/PrimaryLogo.vue';
import UiCodeInput from '@/components/UIElements/UiCodeInput.vue';

export default {
  name: 'TfaSetup',
  components: {
    UiCodeInput,
    PrimaryLogo,
  },

  data() {
    return {
      code: '',
      errors: {},
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      qrSrc: 'auth/qrSrc',
    }),
  },

  methods: {
    async signOut() {
      try {
        await this.$store.dispatch(`auth/${AUTH_LOGOUT}`);
        this.$router.push({
          name: 'login',
          params: {
            action: 'auth',
          },
        });
      } catch (error) {
        this.errors = error.data.errors;
      }
    },

    confirmCode(code) {
      this.code = code;
      this.qrSetup();
    },

    async qrSetup() {
      this.errors = {};

      if (this.code !== '') {
        this.isLoading = true;
        const payload = {
          token: this.code,
          trust: false,
        };
        try {
          await this.$store.dispatch(`auth/${AUTH_2FA_REQUEST}`, payload);
          await bootstrapApp({ force: true });
          this.$store.commit(`auth/${AUTH_2FA_SUCCESS}`);
          this.$router.push('/affiliates');
        } catch (error) {
          this.errors = error;
          this.$eventBus.$emit('notify-event', {
            type: 'error',
            text: error.message,
          });
        } finally {
          this.isLoading = false;
        }
      } else {
        this.errors = {
          token: [{ code: 1000 }],
        };
        this.$eventBus.$emit('notify-event', {
          type: 'error',
          text: this.$t('loginView.codeIsRequired'),
        });
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.qrSrc) {
        next(from);
      }
      next();
    });
  },
};
</script>
